module.exports = __webpack_public_path__ + "136086f2eebd758c4cf8311f0b18f125.svg";